/* Kuk arama katmanı (sop/baslik-menu-arama.json 18-25; işaretleme snippets/kuk-arama-katmani.liquid).
   Ara ikonu ([data-arama-ac]) ya da sonuç sayfasındaki kutu ([data-arama-ac-girdi]) katmanı açar; kutu aynı dokunuşta
   odaklanır (klavye açılır). 2. harften sonra yazma durunca 200 ms beklenir, Shopify anlık arama ucu Section Rendering
   ile istenir (sections/kuk-arama-onerileri.liquid), önceki istek iptal edilir; cevap 300 ms'yi geçerse 3 iskelet satır.
   Hata olursa boş hal döner, Enter yine sonuç sayfasına gider. Panel kaydırılınca klavye kapanır; ok tuşlarıyla satırlar
   arasında gezilir; sonuç sayısı aria-live ile duyurulur. Kapat, Escape ve Android geri tuşu kapatır (history), sayfa
   konumu korunur. Menü açıkken açılırsa geçmiş kaydı menünün geri adımı bitince eklenir. Ölçüm: arama_sonucsuz
   (yazma durduktan 1,2 sn sonra, aynı terim bir kez). JS yoksa Ara ikonu /search sayfasına gider. */
(() => {
  if (window.kukArama) return;
  const dialog = document.querySelector('[data-kuk-arama]');
  if (!dialog) return;
  window.kukArama = true;

  const ortak = () => window.kukOrtak;
  const girdi = dialog.querySelector('[data-arama-girdi]');
  const temizle = dialog.querySelector('[data-arama-temizle]');
  const govde = dialog.querySelector('[data-arama-govde]');
  const bos = dialog.querySelector('[data-arama-bos]');
  const iskelet = dialog.querySelector('[data-arama-iskelet]');
  const sonuc = dialog.querySelector('[data-arama-sonuc]');
  const durum = dialog.querySelector('[data-arama-durum]');
  const metinler = { sonuc: dialog.dataset.durumSonuc || '[sayi]', yok: dialog.dataset.durumYok || '' };
  const kucuk = (s) => s.toLocaleLowerCase('tr');

  let istek = null;
  let yazmaSayaci = null;
  let iskeletSayaci = null;
  let olaySayaci = null;
  let sonOlayTerimi = '';
  let gecmisBekliyor = false;
  let gecmisGeriAl = true;

  const gecmisEkle = () => window.history.pushState({ ...(window.history.state || {}), kukArama: true }, '');

  const bosGoster = () => {
    if (istek) istek.abort();
    clearTimeout(iskeletSayaci);
    clearTimeout(olaySayaci);
    bos.hidden = false;
    iskelet.hidden = true;
    sonuc.hidden = true;
    sonuc.replaceChildren();
    girdi.setAttribute('aria-expanded', 'false');
    durum.textContent = '';
  };

  const ac = (deger = '') => {
    if (dialog.open) return;
    dialog.showModal();
    ortak()?.kilit.ac();
    girdi.value = deger;
    temizle.hidden = !deger;
    bosGoster();
    girdi.focus();
    if (deger) { girdi.select(); if (deger.trim().length >= 2) getir(deger.trim()); }
    // Menü kapanırken geçmişte geri gidiyorsa kayıt o adım bitince eklenir (yoksa geri adımı katmanı kapatırdı)
    if (document.querySelector('kuk-baslik')?.gecmisBekliyor) gecmisBekliyor = true;
    else gecmisEkle();
  };

  const kapat = (gecmis = true) => {
    if (!dialog.open) return;
    gecmisGeriAl = gecmis;
    dialog.close();
  };

  dialog.addEventListener('close', () => {
    ortak()?.kilit.kapat();
    if (istek) istek.abort();
    clearTimeout(yazmaSayaci);
    clearTimeout(olaySayaci);
    if (gecmisGeriAl && window.history.state && window.history.state.kukArama) window.history.back();
    gecmisGeriAl = true;
  });
  dialog.addEventListener('cancel', (e) => { e.preventDefault(); kapat(true); });
  window.addEventListener('popstate', () => {
    if (gecmisBekliyor) { gecmisBekliyor = false; if (dialog.open) gecmisEkle(); return; }
    if (dialog.open && !(window.history.state && window.history.state.kukArama)) kapat(false);
  });

  // Eşleşen kısım kalın (ürün adı, koleksiyon ve yazı başlığı)
  const vurgula = (q) => {
    const k = kucuk(q);
    sonuc.querySelectorAll('[data-vurgula]').forEach((el) => {
      const metin = el.textContent;
      const i = kucuk(metin).indexOf(k);
      if (i < 0) return;
      const kalin = document.createElement('strong');
      kalin.textContent = metin.slice(i, i + q.length);
      el.replaceChildren(metin.slice(0, i), kalin, metin.slice(i + q.length));
    });
  };

  const olayPlanla = (q) => {
    clearTimeout(olaySayaci);
    olaySayaci = setTimeout(() => {
      if (kucuk(q) === sonOlayTerimi) return;
      sonOlayTerimi = kucuk(q);
      ortak()?.olay('arama_sonucsuz', { terim: q, sayfa_tipi: 'arama' });
    }, 1200);
  };

  const getir = async (q) => {
    if (istek) istek.abort();
    istek = new AbortController();
    clearTimeout(iskeletSayaci);
    iskeletSayaci = setTimeout(() => { iskelet.hidden = false; bos.hidden = true; sonuc.hidden = true; }, 300);
    const p = new URLSearchParams({ q, section_id: 'kuk-arama-onerileri' });
    p.append('resources[type]', 'product,query,collection,article');
    p.append('resources[limit]', '4');
    p.append('resources[limit_scope]', 'each');
    p.append('resources[options][unavailable_products]', 'last');
    p.append('resources[options][fields]', 'title,product_type,variants.title,tag');
    try {
      const yanit = await fetch(`${dialog.dataset.oneriUrl || '/search/suggest'}?${p}`, { signal: istek.signal });
      if (!yanit.ok) throw new Error(String(yanit.status));
      const belge = new DOMParser().parseFromString(await yanit.text(), 'text/html');
      const icerik = belge.querySelector('[data-arama-oneri-icerik]');
      if (!icerik) throw new Error('icerik');
      if (girdi.value.trim() !== q) return;
      sonuc.replaceChildren(document.importNode(icerik, true));
      vurgula(q);
      clearTimeout(iskeletSayaci);
      iskelet.hidden = true;
      bos.hidden = true;
      sonuc.hidden = false;
      govde.scrollTop = 0;
      girdi.setAttribute('aria-expanded', 'true');
      const toplam = Number(icerik.dataset.toplam || 0);
      durum.textContent = toplam ? metinler.sonuc.replace('[sayi]', toplam) : metinler.yok;
      if (!toplam) olayPlanla(q);
    } catch (hata) {
      if (hata.name === 'AbortError') return;
      bosGoster();
    } finally {
      clearTimeout(iskeletSayaci);
      if (girdi.value.trim() === q) iskelet.hidden = true;
    }
  };

  girdi.addEventListener('input', () => {
    const q = girdi.value.trim();
    temizle.hidden = !girdi.value;
    clearTimeout(yazmaSayaci);
    clearTimeout(olaySayaci);
    if (q.length < 2) { bosGoster(); return; }
    yazmaSayaci = setTimeout(() => getir(q), 200);
  });
  temizle.addEventListener('click', () => {
    girdi.value = '';
    temizle.hidden = true;
    bosGoster();
    girdi.focus();
  });
  dialog.querySelector('[data-arama-kapat]').addEventListener('click', () => kapat(true));
  // Boş arama gönderilmez
  dialog.querySelector('[data-arama-form]').addEventListener('submit', (e) => { if (!girdi.value.trim()) { e.preventDefault(); girdi.focus(); } });
  // Panel kaydırılınca klavye kapanır
  govde.addEventListener('touchmove', () => { if (document.activeElement === girdi) girdi.blur(); }, { passive: true });

  // Ok tuşları: kutudan ilk satıra, satırlar arasında; yukarı ok ilk satırdan kutuya döner
  dialog.addEventListener('keydown', (e) => {
    // Escape, kutu doluyken de katmanı kapatır (arama kutusunun kendi 'temizle' davranışı yerine)
    if (e.key === 'Escape') { e.preventDefault(); kapat(true); return; }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const satirlar = [...(sonuc.hidden ? bos : sonuc).querySelectorAll('[data-arama-satir]')];
    if (!satirlar.length) return;
    const i = satirlar.indexOf(document.activeElement);
    if (document.activeElement !== girdi && i < 0) return;
    e.preventDefault();
    if (e.key === 'ArrowDown') satirlar[Math.min(i + 1, satirlar.length - 1)].focus();
    else if (i <= 0) girdi.focus();
    else satirlar[i - 1].focus();
  });

  // Sonuç sayfası filtresiz 0 sonuçla açıldıysa arama_sonucsuz bir kez
  const sonucsuz = document.querySelector('[data-arama-sonucsuz]');
  if (sonucsuz && sonucsuz.dataset.aramaSonucsuz) ortak()?.olay('arama_sonucsuz', { terim: sonucsuz.dataset.aramaSonucsuz, sayfa_tipi: 'arama' });

  document.addEventListener('click', (e) => {
    const ikon = e.target.closest('[data-arama-ac]');
    if (ikon && !e.metaKey && !e.ctrlKey && !e.shiftKey) { e.preventDefault(); ac(); return; }
    const kutu = e.target.closest('[data-arama-ac-girdi]');
    if (kutu) { e.preventDefault(); kutu.blur(); ac(kutu.value); }
  });
})();
